import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { PendoLoading } from '../../directives/loading/pendo-loading.js';

function getDefault(key) {
  return PendoLoading.options[key];
}
const SIZE_MAP = {
  small: 16,
  medium: 32,
  large: 48
};
var script = {
  name: 'PendoLoadingIndicator',
  directives: {
    PendoLoading
  },
  props: {
    size: {
      type: String,
      default: 'medium',
      validator: size => ['small', 'medium', 'large'].includes(size)
    },
    light: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: true
    },
    button: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'material'
    },
    text: {
      type: String,
      default: () => getDefault('text')
    },
    textClass: {
      type: String,
      default: () => getDefault('textClass')
    },
    overlayProps: {
      type: Object,
      default: () => ({})
    },
    spinnerProps: {
      type: Object,
      default: () => ({})
    },
    skeletonProps: {
      type: Object,
      default: () => ({})
    },
    preventRelativeParent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loaderConfig() {
      const {
        loading,
        light,
        type,
        text,
        textClass,
        preventRelativeParent,
        spinnerProps,
        skeletonProps,
        overlayProps
      } = this;
      const {
        size
      } = this.$options.propsData;
      const conditionalSpinnerProps = {};
      if (light) {
        conditionalSpinnerProps.color = '#F8F8F9';
      }
      if (size && isNaN(size)) {
        conditionalSpinnerProps.size = SIZE_MAP[size];
      }
      return {
        loading,
        type,
        text,
        textClass,
        preventRelativeParent,
        overlayProps: _objectSpread2(_objectSpread2(_objectSpread2({}, getDefault('overlayProps')), overlayProps), {}, {
          position: 'inherit'
        }),
        spinnerProps: _objectSpread2(_objectSpread2(_objectSpread2({}, getDefault('spinnerProps')), {}, {
          background: 'transparent'
        }, spinnerProps), conditionalSpinnerProps),
        skeletonProps: _objectSpread2(_objectSpread2({}, getDefault('skeletonProps')), skeletonProps)
      };
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-loading-indicator.vue2.js.map
